// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1DBXXThWgHo9mWWC7il-UA{margin:1px 0 0 5px}", "",{"version":3,"sources":["webpack://./resources/js/components/AppHeader/TopHeader/styles.module.scss"],"names":[],"mappings":"AAAA,yBACI,kBACJ","sourcesContent":[".dropdown_icon {\n    margin: 1px 0 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown_icon": "_1DBXXThWgHo9mWWC7il-UA"
};
export default ___CSS_LOADER_EXPORT___;
